import React from 'react';
import PropTypes from 'prop-types';
import TextField from '../mdc/TextField';
import SearchResults from './SearchResults';
import apolloClient from '../../services/apolloClient';
import queries from '../../graphql/queries';
import { compose } from 'react-apollo';
import './SearchDialog.css';

class SearchDialog extends React.Component {

    constructor(props) {
        super(props);

        this.searchText = '';
        this.searchTextOfRenderedResults = '';
        this.requestCount = 0;
        this.lastReceivedRequestId = 0;
        this.state = {
            results: null,
            loading: false
        };
    }

    onChange(searchText) {
        this.searchText = searchText;

        // If user entered less than three characters show nothing and return - do not execute the query
        if (searchText.length < 3) {
            this.searchTextOfRenderedResults = '';
            this.setState({
                results: null,
                loading: false
            });
            return;
        }

        // If previous results were found for something that is not prefix of current search text, remove them
        if (!searchText.startsWith(this.searchTextOfRenderedResults)) {
            this.searchTextOfRenderedResults = '';
            this.setState({results: null});
        }

        let requestIncrementId = ++this.requestCount;

        this.setState({loading: true});

        apolloClient.query({
            query: queries.searchQuery,
            fetchPolicy: 'network-only',
            variables: {
                projectId: this.props.project.id,
                searchText: searchText
            }
        }).then(apolloQueryResult => {

            // Process responses in incremented order
            if (requestIncrementId < this.lastReceivedRequestId) {
                return;
            }

            // Ignore responses of searchText that are not part of current search string
            if (!this.searchText.startsWith(searchText)) {
                return;
            }

            this.lastReceivedRequestId = requestIncrementId;
            this.searchTextOfRenderedResults = searchText;

            this.setState({
                results: apolloQueryResult.data.search,
                loading: requestIncrementId !== this.requestCount
            });
        });
    }

    render() {
        return (
            <div className="searchDialog">
                <TextField
                    fullWidth={true}
                    autoFocus={true}
                    rootClassName="searchTextField"
                    id="searchTextField"
                    placeholder="Search for an item"
                    onChange={(event) => this.onChange(event.target.value)}
                />
                <SearchResults
                    loading={this.state.loading}
                    results={this.state.results}
                    project={this.props.project}
                />
            </div>
        );
    }

}

SearchDialog.propTypes = {
    project: PropTypes.object.isRequired
};
SearchDialog.defaultProps = {};

export default compose(

)(SearchDialog);



// WEBPACK FOOTER //
// ./src/components/search/SearchDialog.js